module.exports = __webpack_public_path__ + "static/img/13.b2c0987.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/eng/13.png
// module id = 4AQ4
// module chunks = 0